// extracted by mini-css-extract-plugin
export default {"starterScreen":"tl","starterImage":"ul","already":"vl","btnContainer":"wl","starterImageMobile":"xl","starterTextContainWrapper":"yl","controlX":"zl","attrWrapper":"Al","logoWrapper":"Bl","starterTextContain":"Cl","starterHeader":"El","starterBtn":"Fl","starterSecondaryBtn":"Gl","starterBanner":"Hl","logoWrapperMob":"Il","mobileBtnContainer":"Jl"};
    if(module.hot) {
      // 1711394575570
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  